/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3DailyStatsFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3DailyStatsFormat = ClosedEnum<
  typeof GetApiV3DailyStatsFormat
>;

export type GetApiV3DailyStatsRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3DailyStatsFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
};

/** @internal */
export const GetApiV3DailyStatsFormat$inboundSchema: z.ZodNativeEnum<
  typeof GetApiV3DailyStatsFormat
> = z.nativeEnum(GetApiV3DailyStatsFormat);

/** @internal */
export const GetApiV3DailyStatsFormat$outboundSchema: z.ZodNativeEnum<
  typeof GetApiV3DailyStatsFormat
> = GetApiV3DailyStatsFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DailyStatsFormat$ {
  /** @deprecated use `GetApiV3DailyStatsFormat$inboundSchema` instead. */
  export const inboundSchema = GetApiV3DailyStatsFormat$inboundSchema;
  /** @deprecated use `GetApiV3DailyStatsFormat$outboundSchema` instead. */
  export const outboundSchema = GetApiV3DailyStatsFormat$outboundSchema;
}

/** @internal */
export const GetApiV3DailyStatsRequest$inboundSchema: z.ZodType<
  GetApiV3DailyStatsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  end: z.nullable(z.number().int()).default(null),
  format: GetApiV3DailyStatsFormat$inboundSchema.default("json"),
  start: z.nullable(z.number().int()).default(null),
});

/** @internal */
export type GetApiV3DailyStatsRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
};

/** @internal */
export const GetApiV3DailyStatsRequest$outboundSchema: z.ZodType<
  GetApiV3DailyStatsRequest$Outbound,
  z.ZodTypeDef,
  GetApiV3DailyStatsRequest
> = z.object({
  end: z.nullable(z.number().int()).default(null),
  format: GetApiV3DailyStatsFormat$outboundSchema.default("json"),
  start: z.nullable(z.number().int()).default(null),
});

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3DailyStatsRequest$ {
  /** @deprecated use `GetApiV3DailyStatsRequest$inboundSchema` instead. */
  export const inboundSchema = GetApiV3DailyStatsRequest$inboundSchema;
  /** @deprecated use `GetApiV3DailyStatsRequest$outboundSchema` instead. */
  export const outboundSchema = GetApiV3DailyStatsRequest$outboundSchema;
  /** @deprecated use `GetApiV3DailyStatsRequest$Outbound` instead. */
  export type Outbound = GetApiV3DailyStatsRequest$Outbound;
}

export function getApiV3DailyStatsRequestToJSON(
  getApiV3DailyStatsRequest: GetApiV3DailyStatsRequest,
): string {
  return JSON.stringify(
    GetApiV3DailyStatsRequest$outboundSchema.parse(getApiV3DailyStatsRequest),
  );
}

export function getApiV3DailyStatsRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetApiV3DailyStatsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetApiV3DailyStatsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetApiV3DailyStatsRequest' from JSON`,
  );
}
